import i18n from "i18next";
import {
	SupplierSalesOrderIntegrationFormOption
} from "src/components/views/erp/purchase/suppliers/SupplierSalesOrderIntegrationFormCustomization.ts";

export function getLinjaterasSupplierSalesOrderIntegrationFormOption(): SupplierSalesOrderIntegrationFormOption {
	return {
		key: "LINJATERAS_SIRMET",
		label: i18n.t("linjateras"),
		isSelected: (integrationConfig) =>
			integrationConfig.type === "TENANT_SPECIFIC" &&
			integrationConfig.integrationType === "LINJATERAS_SIRMET",
		createIntegrationConfig: () => ({
			type: "TENANT_SPECIFIC",
			integrationType: "LINJATERAS_SIRMET",
		}),
	};
}
